/* 25HOURS h25-tracking front-end (vanilla JS, no deps) — H2 (2026-06-01)
 * Calls https://pixel.25hours.net/track/query, renders 4 states.
 * H2: + initial-state contact card / factory disclaimer / About Us link / improved timeline visuals.
 */
(function () {
  'use strict';

  var CFG = window.H25_TRACKING_CONFIG || {};
  var API = CFG.api;
  var LOCALE = CFG.locale === 'de' ? 'de' : 'en';
  var WHATSAPP = CFG.whatsapp || '+44 7512 976170';
  var WHATSAPP_LINK = CFG.whatsapp_link || 'https://wa.me/447512976170';
  var EMAIL = CFG.email || 'support@25hours.net';
  var ABOUT_LINK = LOCALE === 'de'
    ? 'https://25hours.net/de/pages/about-us'
    : 'https://25hours.net/pages/about-us';

  /* ── Carrier path map ── */
  var CARRIER_PATHS = {
    'DE': 'China Post → DHL'
    // future: add other countries here when confirmed
  };

  /* ── i18n ── */
  var T = {
    loading: { en: 'Looking up your shipment…', de: 'Sendung wird geprüft…' },
    shipped_via: { en: 'Shipped via', de: 'Versendet über' },
    status_label: {
      en: { Delivered: 'Delivered', InTransit: 'In transit', PickUp: 'Picked up', OutForDelivery: 'Out for delivery', InfoReceived: 'Info received', Expired: 'Expired', Undelivered: 'Undelivered', Alert: 'Alert' },
      de: { Delivered: 'Zugestellt', InTransit: 'Unterwegs', PickUp: 'Abgeholt', OutForDelivery: 'In Zustellung', InfoReceived: 'Information erhalten', Expired: 'Abgelaufen', Undelivered: 'Nicht zugestellt', Alert: 'Hinweis' }
    },
    need_help: { en: 'Need help?', de: 'Brauchen Sie Hilfe?' },
    /* H2 NEW */
    factory_disclaimer: {
      en: 'Every 25HOURS piece is designed by us and made at one of our three partner workshops — in Bangkok, Jaipur, or Panyu. Different pieces may dispatch from different workshops. This is normal.',
      de: 'Jedes 25HOURS-Stück wird von uns entworfen und in einer unserer drei Partnerwerkstätten in Bangkok, Jaipur oder Panyu gefertigt. Verschiedene Stücke können von unterschiedlichen Werkstätten versendet werden. Das ist normal.'
    },
    learn_more: { en: 'Learn more about us →', de: 'Mehr über uns →' },
    initial_help_prefix: {
      en: 'Have a tracking number? Enter it above. Don’t have one yet, or need help looking it up?',
      de: 'Sie haben eine Sendungsnummer? Geben Sie sie oben ein. Noch keine? Oder brauchen Sie Hilfe beim Nachschlagen?'
    },
    /* State B */
    preparing_title: { en: 'Your parcel is on its way', de: 'Ihr Paket ist unterwegs' },
    preparing_body: {
      en: "We've handed your order to the carrier. Tracking updates will appear here shortly. No worries — your package is safely on its way.",
      de: 'Wir haben Ihre Bestellung an den Versanddienstleister übergeben. Aktualisierungen erscheinen hier in Kürze. Keine Sorge — Ihr Paket ist sicher unterwegs.'
    },
    preparing_help: { en: 'Questions? Reach us anytime:', de: 'Fragen? Sie erreichen uns jederzeit:' },
    /* State C */
    notfound_title: { en: "Let's double-check that number", de: 'Lassen Sie uns die Nummer noch einmal prüfen' },
    notfound_body: {
      en: "We only track orders shipped by 25HOURS. Please compare your number with the one in your shipping confirmation email — small typos happen. If you're sure it's a 25HOURS order, message us and we'll look it up for you.",
      de: 'Wir verfolgen nur Bestellungen, die von 25HOURS versendet wurden. Bitte vergleichen Sie Ihre Nummer mit der in Ihrer Versandbestätigung — kleine Tippfehler passieren. Wenn Sie sicher sind, dass es sich um eine 25HOURS-Bestellung handelt, schreiben Sie uns und wir suchen sie für Sie.'
    },
    /* State D */
    maintenance_title: { en: 'Tracking is briefly under maintenance', de: 'Sendungsverfolgung wird kurz gewartet' },
    maintenance_body: {
      en: "We're updating our tracking service. For the fastest update on your order, message us directly — we'll look it up manually right away. Your order is 100% safe.",
      de: 'Wir aktualisieren gerade unseren Sendungsverfolgungsdienst. Für die schnellste Aktualisierung zu Ihrer Bestellung schreiben Sie uns bitte direkt — wir prüfen sie sofort manuell für Sie. Ihre Bestellung ist zu 100% sicher.'
    }
  };

  function t(key) {
    var v = T[key];
    return v && v[LOCALE] ? v[LOCALE] : '';
  }

  function statusLabel(status) {
    if (!status) return '';
    var dict = T.status_label[LOCALE] || {};
    return dict[status] || status;
  }

  function formatDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      var months_en = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var months_de = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
      var months = LOCALE === 'de' ? months_de : months_en;
      var hh = String(d.getHours()).padStart(2, '0');
      var mm = String(d.getMinutes()).padStart(2, '0');
      return months[d.getMonth()] + ' ' + d.getDate() + '  ' + hh + ':' + mm;
    } catch (e) { return iso; }
  }

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function contactBlock(emphasize) {
    var cls = emphasize ? 'h25-contact h25-contact--emphasize' : 'h25-contact';
    return ''
      + '<div class="' + cls + '">'
      + '<a href="' + esc(WHATSAPP_LINK) + '" target="_blank" rel="noopener" class="h25-contact-link h25-contact-wa">'
      + '<span class="h25-contact-icon" aria-hidden="true">📱</span> ' + esc(WHATSAPP)
      + '</a>'
      + '<a href="mailto:' + esc(EMAIL) + '" class="h25-contact-link h25-contact-email">'
      + '<span class="h25-contact-icon" aria-hidden="true">✉️</span> ' + esc(EMAIL)
      + '</a>'
      + '</div>';
  }

  /* H2 NEW: factory disclaimer block (used in initial-state card + appended below timeline in OK card) */
  function disclaimerBlock() {
    return ''
      + '<p class="h25-tr-disclaimer">'
      +   esc(t('factory_disclaimer'))
      +   ' <a href="' + esc(ABOUT_LINK) + '" class="h25-tr-about-link">' + esc(t('learn_more')) + '</a>'
      + '</p>';
  }

  function getCarrierPath(payload) {
    if (!payload) return null;
    var ship = payload.shipping_info;
    var country = ship && ship.recipient_address && ship.recipient_address.country;
    if (country && CARRIER_PATHS[String(country).toUpperCase()]) {
      return CARRIER_PATHS[String(country).toUpperCase()];
    }
    if (Array.isArray(payload.carriers) && payload.carriers.length > 0) {
      return payload.carriers.join(' → ');
    }
    var events = Array.isArray(payload.events) ? payload.events : [];
    var seen = {};
    var carriers = [];
    for (var i = events.length - 1; i >= 0; i--) {
      var p = events[i] && events[i].provider;
      if (p && !seen[p]) { seen[p] = true; carriers.push(p); }
    }
    return carriers.length > 0 ? carriers.join(' → ') : null;
  }

  /* ── State A: ok ── */
  function renderOk(payload, num) {
    var status = payload.latest_status || '';
    var isDelivered = String(status).toLowerCase() === 'delivered';
    var events = payload.events || [];
    var carrierPath = getCarrierPath(payload);

    var headerHtml = ''
      + '<div class="h25-tr-header">'
      +   '<div class="h25-tr-header-left">'
      +     '<div class="h25-tr-tn">' + esc(num) + '</div>'
      +   '</div>'
      +   '<div class="h25-tr-header-right">'
      +     '<div class="h25-tr-status' + (isDelivered ? ' h25-tr-status--delivered' : '') + '">'
      +       esc(statusLabel(status))
      +       (isDelivered ? ' <span class="h25-tr-check" aria-hidden="true">✓</span>' : '')
      +     '</div>'
      +   '</div>'
      + '</div>';

    var carrierHtml = '';
    if (carrierPath) {
      carrierHtml = ''
        + '<div class="h25-tr-carrier">'
        +   '<span class="h25-tr-carrier-label">' + esc(t('shipped_via')) + ':</span> '
        +   '<span class="h25-tr-carrier-path">' + esc(carrierPath) + '</span>'
        + '</div>';
    }

    var eventsHtml = events.map(function (e, idx) {
      var delivered = idx === 0 && isDelivered;
      return ''
        + '<li class="h25-tl-item' + (delivered ? ' h25-tl-item--delivered' : '') + '">'
        +   '<div class="h25-tl-dot" aria-hidden="true"></div>'
        +   '<div class="h25-tl-content">'
        +     '<div class="h25-tl-meta">'
        +       '<span class="h25-tl-time">' + esc(formatDate(e.time)) + '</span>'
        +       (e.location ? '<span class="h25-tl-location">' + esc(e.location) + '</span>' : '')
        +     '</div>'
        +     '<div class="h25-tl-desc">' + esc(e.description || '') + '</div>'
        +   '</div>'
        + '</li>';
    }).join('');

    var html = ''
      + '<div class="h25-tr-card h25-tr-card--ok">'
      +   headerHtml
      +   carrierHtml
      +   '<ul class="h25-tl">' + eventsHtml + '</ul>'
      +   '<div class="h25-tr-help">'
      +     disclaimerBlock()
      +     '<span class="h25-tr-help-prefix">' + esc(t('need_help')) + '</span>'
      +     contactBlock(false)
      +   '</div>'
      + '</div>';
    setResult(html);
  }

  function renderPreparing() {
    var html = ''
      + '<div class="h25-tr-card h25-tr-soft">'
      +   '<h2 class="h25-tr-soft-title">' + esc(t('preparing_title')) + '</h2>'
      +   '<p class="h25-tr-soft-body">' + esc(t('preparing_body')) + '</p>'
      +   disclaimerBlock()
      +   '<p class="h25-tr-soft-help">' + esc(t('preparing_help')) + '</p>'
      +   contactBlock(false)
      + '</div>';
    setResult(html);
  }

  function renderNotInRecords() {
    var html = ''
      + '<div class="h25-tr-card h25-tr-soft">'
      +   '<h2 class="h25-tr-soft-title">' + esc(t('notfound_title')) + '</h2>'
      +   '<p class="h25-tr-soft-body">' + esc(t('notfound_body')) + '</p>'
      +   disclaimerBlock()
      +   contactBlock(false)
      + '</div>';
    setResult(html);
  }

  function renderMaintenance() {
    var html = ''
      + '<div class="h25-tr-card h25-tr-soft h25-tr-maintenance">'
      +   '<h2 class="h25-tr-soft-title">' + esc(t('maintenance_title')) + '</h2>'
      +   '<p class="h25-tr-soft-body">' + esc(t('maintenance_body')) + '</p>'
      +   disclaimerBlock()
      +   contactBlock(true)
      + '</div>';
    setResult(html);
  }

  /* H2 NEW: initial-state card (before user submits anything) */
  function renderInitial() {
    var html = ''
      + '<div class="h25-tr-card h25-tr-soft h25-tr-initial">'
      +   disclaimerBlock()
      +   '<p class="h25-tr-soft-help">' + esc(t('initial_help_prefix')) + '</p>'
      +   contactBlock(false)
      + '</div>';
    setResult(html);
  }

  function setResult(html) {
    var el = document.getElementById('h25-tracking-result');
    if (el) el.innerHTML = html;
  }

  function showLoading() {
    setResult('<div class="h25-tr-loading">' + esc(t('loading')) + '</div>');
  }

  function init() {
    var form = document.getElementById('h25-tracking-form');
    var input = document.getElementById('h25-tn-input');
    if (!form || !input || !API) return;

    renderInitial();

    try {
      var qs = new URLSearchParams(window.location.search);
      var prefill = qs.get('num') || qs.get('tracking') || qs.get('n');
      if (prefill) {
        input.value = prefill.trim().toUpperCase();
        setTimeout(function () { form.dispatchEvent(new Event('submit', { cancelable: true })); }, 50);
      }
    } catch (e) { /* ignore */ }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = (input.value || '').trim().toUpperCase();
      input.value = num;
      if (num.length < 6) {
        renderNotInRecords();
        return;
      }
      showLoading();
      var url = API + '?num=' + encodeURIComponent(num) + '&lang=' + encodeURIComponent(LOCALE);
      fetch(url, { method: 'GET', credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          return r.json();
        })
        .then(function (d) {
          var status = (d && d.status) || 'maintenance';
          if (status === 'ok') renderOk(d, num);
          else if (status === 'carrier_preparing') renderPreparing();
          else if (status === 'not_in_our_records') renderNotInRecords();
          else if (status === 'invalid_number') renderNotInRecords();
          else if (status === 'maintenance') renderMaintenance();
          else renderMaintenance();
        })
        .catch(function () { renderMaintenance(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
